import axios from 'axios';
import router from '../../router';
import Crypto from 'crypto-js';
import Cookie from 'js-cookie';
import { v4 as uuid } from 'uuid';

const cookieName = 'monitoramento-storage';
let encryptionToken = Cookie.get(cookieName) || uuid();
Cookie.set(cookieName, encryptionToken, { secure: process.env.SECURE_COOKIE, expires: 1 });

const storage = {
    getItem: (key) => {
        const store = localStorage.getItem(key);

        if (store) {
            try {
                const bytes = Crypto.AES.decrypt(store, encryptionToken);
                return JSON.parse(bytes.toString(Crypto.enc.Utf8));

            } catch (e) {
                localStorage.clear();
            }
        }

        return null;
    },
    setItem: (key, value) => {
        const store = Crypto.AES.encrypt(JSON.stringify(value), encryptionToken).toString();
        return localStorage.setItem(key, store);
    },
    removeItem: (key) => {
        localStorage.removeItem(key)
    },
    removeAll: () => {
        localStorage.clear();
    }
};

const state = {
    token: storage.getItem("token"),
    token_update_date: new Date(storage.getItem("token_update_date")),
    isFetching: false,
    username: '',
    user: {
        roles: storage.getItem("papeis") ? storage.getItem("papeis") : []
    }
};

const actions = {
    login({ commit, dispatch }, authData) {
        dispatch('requestOn');
        return new Promise((resolve) => {
            axios.post('/login', {
                username: authData.username,
                password: authData.password
            })
                .then(res => {
                    const date = new Date();
                    dispatch('requestOff');
                    commit('AUTHENTICATE', { token: res.data.token, papeis: res.data.papeis, date: date, username: res.data.username },)
                })
                .finally(() => { dispatch('requestOff'); resolve()} )

        })
    },
    logout({ commit }) {
        commit('CLEAR_AUTH_DATA');
        router.push('/login')
    },
    updateToken({ commit }, tokenData) {
        const date = new Date();
        commit('UPDATE_AUTH_DATA', { token: tokenData.token, date: date });
    },
    removeToken({ commit }) {
        commit('CLEAR_AUTH_DATA')
    },
    recuperarSenha({ commit, dispatch }, email) {
        commit;
        dispatch('requestOn');
        return axios.get("/public/usuario/recuperacao?email=" + email).then(response => {
            response;
            dispatch('requestOff');
        })
    },    
    novaSenha({ commit }, token) {
        commit;
        return axios.post('public/usuario/nova-senha', token)
    },

    requestOff({commit}) {
        commit('FETCHING_OFF');
    },
    requestOn({commit}) {
        commit('FETCHING_ON');
    },    
};

const getters = {
    isAuthenticated(state) {
        return state.token !== null;
    },
    isValidDateToken(state) {
        return new Date() <= new Date(state.token_update_date).addHours(1);
    },
    token(state) {
        return state.token
    },
    user(state) {
        return state.user
    },
    username(state) {
        return state.username
    },
    isAdministrador(state) {
        return state.user.roles.includes('ADMINISTRADOR_SISTEMA');
    },
    isCoordenador(state) {
        return state.user.roles.includes('COORDENADOR_SISTEMA');
    },    
    isUsuario(state) {
        return state.user.roles.includes('USUARIO');
    }
};

const mutations = {
    AUTHENTICATE: (state, authUser) => {
        encryptionToken = uuid();

        state.token = authUser.token;
        state.user.roles = authUser.papeis;
        state.token_update_date = authUser.date;
        state.username = authUser.username;

        storage.setItem('token', authUser.token);
        storage.setItem('papeis', authUser.papeis);
        storage.setItem('token_update_date', authUser.date);

        Cookie.set(cookieName, encryptionToken, { secure: process.env.SECURE_COOKIE, expires: new Date(authUser.date).addHours(1) });
    },
    UPDATE_AUTH_DATA: (state, tokenData) => {
        state.token = tokenData.token;
        state.token_update_date = tokenData.date;

        storage.setItem('token', tokenData.token);
        storage.setItem('token_update_date', tokenData.date);

        Cookie.set(cookieName, encryptionToken, { secure: process.env.SECURE_COOKIE, expires: new Date(tokenData.date).addHours(1) });
    },
    CLEAR_AUTH_DATA: (state) => {
        state.token = null;
        state.user.roles = null;
        state.token_update_date = null;

        storage.removeAll();

        Cookie.remove(cookieName);
    },
    FETCHING_OFF(state) {
        state.isFetching = false;
    },
    FETCHING_ON(state) {
        state.isFetching = true;
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
